import classNames from 'classnames';
import React from 'react';
import styles from './GradientOverlay.module.scss';

export interface GradientOverlayProps {
  className?: string;
  borderRadius?: number | string;
  zIndex?: number;
  backdropBlur?: number | string;
  height?: number | string;
  variant?: 'full' | 'bottom-blur';
}

export const GradientOverlay: React.FC<GradientOverlayProps> = ({
  className,
  borderRadius,
  zIndex,
  backdropBlur,
  height,
  variant = 'full',
}) => {
  const cssVars: React.CSSProperties & Record<string, string | undefined> = {
    ...(borderRadius !== undefined && {
      '--border-radius': typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
    }),
    ...(zIndex !== undefined && {
      '--z-index': String(zIndex),
    }),
    ...(backdropBlur !== undefined && {
      '--backdrop-blur': typeof backdropBlur === 'number' ? `${backdropBlur}px` : backdropBlur,
    }),
    ...(height !== undefined && {
      '--height': typeof height === 'number' ? `${height}%` : height,
    }),
  };

  return (
    <div
      className={classNames(
        styles.gradientOverlay,
        variant === 'bottom-blur' && styles.bottomBlur,
        className,
      )}
      style={cssVars}
    >
      {variant === 'full' && <div className={styles.gradientOverlayInner} />}
    </div>
  );
};
